import React, { useState, useEffect } from 'react'

import { Flex, Text, Card } from '@clear/design-system'
import PageContent from '@components/layout/PageContent'
import { CardHeading } from '@components/layout/Heading'
import { HeadTitle } from '@components/layout/HeadTitle'

const ContactUs = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    if (typeof window !== undefined) setCurrentUrl(window.location.href)
  }, [])
  return (
    <Flex flexDirection="column">
      <HeadTitle
        title="Contact Us | TSA PreCheck® Enrollment and Renewal Provided by CLEAR"
        description="Have questions about TSA PreCheck® Enrollment Provided by CLEAR? Please call our service center."
      />
      <PageContent mt={[8, 11]}>
        <Card>
          <CardHeading>Contact Us</CardHeading>
          <Text
            as="p"
            color="neutralsTextGray"
            mx={8}
            my={[4, 7]}
            lineHeight="body"
            textAlign="center"
          >
            If you are unable to find your answer in the{' '}
            <Text as="a" href="/help" color="brandMidnightBlue">
              FAQs{' '}
            </Text>
            and need assistance with a service,{'\u00A0'}
            <Text as="a" href="tel:18888319070" color="brandMidnightBlue">
              please contact our support team.
            </Text>{' '}
            <Text as="p" mt={4}>
              <Text as="a" href="tel:18888319070" color="brandMidnightBlue">
                Call 1-888-831-9070
              </Text>
              , Monday - Friday 8am - 10pm ET
            </Text>
            <Text as="p">
              Email{' '}
              <Text
                as="a"
                href="mailto:CLEARCustomerSupport@tsa.dhs.gov"
                color="brandMidnightBlue"
              >
                CLEARCustomerSupport@tsa.dhs.gov
              </Text>
              , anytime
            </Text>
          </Text>
        </Card>
      </PageContent>
    </Flex>
  )
}

export default ContactUs
